import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { catchError, retry, tap } from 'rxjs/operators';
import { URL_API } from 'src/app/tools/URL';
import { DenunciaVO } from '../../entity/DenunciaVO';
import { ATUALIZAR, CARREGAR, ENVIAR, ErrorsService, SALVAR } from '../errors/errors.service';
import { RestService } from './../rest.service';
import { AuthService } from '../autenticacao/auth.service';
import { MSG_OBG_ASSUNTO, MSG_DENUNCIA_OBG_DESCRICAO_DENUNCIA, MSG_DENUNCIA_OBG_CLASSIFICACAO,
MSG_DENUNCIA_OBG_NOME_CARTORIO, MSG_DENUNCIA_OBG_LOCALIDADE, MSG_DENUNCIA_OBG_MUNICIPIO, MSG_DENUNCIA_OBG_COMARCA,
MSG_DENUNCIA_OBG_ORIGEM_NOTIFICACAO, MSG_DENUNCIA_OBG_TIPO_PESSOA_NOTIFICANTE, MSG_DENUNCIA_OBG_NOME_NOTIFICANTE,
MSG_DENUNCIA_OBG_NOME_SOCIAL_NOTIFICANTE, MSG_DENUNCIA_OBG_CPF_NOTIFICANTE, MSG_DENUNCIA_OBG_CNPJ_NOTIFICANTE,
MSG_DENUNCIA_OBG_RG_NOTIFICANTE,MSG_DENUNCIA_OBG_ORGAO_EXPEDIDOR_NOTIFICANTE, MSG_DENUNCIA_OBG_UF_ORGAO_EXPEDIDOR_NOTIFICANTE,
MSG_DENUNCIA_OBG_EMAIL_NOTIFICANTE, MSG_DENUNCIA_OBG_VITIMAS, MSG_DENUNCIA_OBG_ORGAO_VINCULADO_AGRESSORES,
MSG_DENUNCIA_OBG_OUTROS_ORGAOS, MSG_DENUNCIA_OBG_LOCAL_FATO, MSG_DENUNCIA_OBG_PUBLICO_ORIGEM_NOTIFICACAO,
MSG_DENUNCIA_OBG_COMARCA_OCORRENCIA, MSG_DENUNCIA_OBG_NUMERO_PROCESSO, MSG_DENUNCIA_OBG_TIPOS_DEMANDA,
MSG_DENUNCIA_OBG_NOME_UNIDADE_ACOLHIMENTO } from 'src/app/tools/Mensagens';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DenunciaService {

  denuncia = this.builder.group(this.preencherVo());
  // cache local de perguntas carregadas (mapeamento por id)
  private perguntaById: { [id: string]: any } = {};
  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL = 52;
  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR = 53;
  CLASSIFICACAO_SERVIDOR_INTERIOR = 60;
  CLASSIFICACAO_TORTURA = 154;

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) {
  }

  /** Remove caracteres não numéricos de uma string (telefone) */
  private _stripNonDigits(value: string): string {
    if (value == null) return value as any;
    return String(value).replace(/\D/g, '');
  }

  private unwrap(ret: any): any[] {
    if (!ret) return [];
    if (Array.isArray(ret)) return ret;
    if (ret.lista) return ret.lista;
    if (ret.retorno) return ret.retorno;
    if (ret.data) return ret.data;
    return ret;
  }

  /**
   * Resolve qual valor de funcaoId deve ser enviado no payload para um participante.
   */
  private _resolveFuncaoId(participante: any): any {
    try {
      const rawFunc = participante && participante.funcaoId;
      const isOutroId = (rawFunc !== undefined && rawFunc !== null && (Number(rawFunc) === 9999 || String(rawFunc).toLowerCase().indexOf('outro') !== -1));
      if (isOutroId) return null;
      if (rawFunc === undefined || rawFunc === null) return null;
      if (typeof rawFunc === 'string' && rawFunc.trim() === '') return null;
      return rawFunc;
    } catch (e) {
      return participante && participante.funcaoId || null;
    }
  }

  /**
   * Resolve qual valor de deficienciaId deve ser enviado no payload para um participante
   */
  private _resolveDeficienciaId(participante: any): any {
    try {
      const rawDef = participante && participante.deficienciaId;
      const isOutroId = (rawDef !== undefined && rawDef !== null && (Number(rawDef) === 9999 || String(rawDef).toLowerCase().indexOf('outro') !== -1));
      if (isOutroId) return null;
      if (rawDef === undefined || rawDef === null) return null;
      if (typeof rawDef === 'string' && rawDef.trim() === '') return null;
      return rawDef;
    } catch (e) {
      return participante && participante.deficienciaId || null;
    }
  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_DENUNCIA + '/' + id}`);

  }

  buscarCartoriosBeloHorizonte(){
    return this.rest.get(`${URL_API.PATH_DENUNCIA}/buscarCartoriosBeloHorizonte`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  buscarCartoriosPorCodigoMunicipio(codigoMunicipio : any){
    return this.rest.get(`${URL_API.PATH_DENUNCIA}/buscarCartoriosCodigoMunicipio/` + codigoMunicipio).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  buscarCartoriosPorCodMunicipioCodComarca(codigoMunicipio : any, codigoComarca: any){
    return this.rest.get(`${URL_API.PATH_DENUNCIA}/buscarCartoriosCodMunicipioCodComarca/` + codigoMunicipio + '/' + codigoComarca).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDados() {

  return this.rest.get(`${URL_API.PATH_DENUNCIA}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDadosDenunciaAnonima() {

    return this.rest.get(`${URL_API.PATH_DENUNCIA_ANONIMA}/carregar`).pipe(
        retry(1),
        catchError(response => this.errorsService.handleError(response, CARREGAR))
      );
    }

  carregarCondutas() {
    return this.rest.get(`${URL_API.PATH_CONDUTA_CARREGAR}`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarFuncoes() {
    return this.rest.get(`${URL_API.PATH_FUNCAO_CARREGAR}`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarEscolaridades() {
    return this.rest.get(`${URL_API.PATH_ESCOLARIDADE_CARREGAR}`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarTipoDeficiencias() {
    return this.rest.get(`${URL_API.PATH_TIPO_DEFICIENCIA_CARREGAR}`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarCorRaca() {
    return this.rest.get(`${URL_API.PATH_COR_RACA_CARREGAR}`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarSetores(identificador?: any) {
    const suffix = identificador != null ? ('?identificador=' + identificador) : '';
    return this.rest.get(`${URL_API.PATH_SETOR_CARREGAR}` + suffix).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarSetorPorComarca(comrCodigo: any) {
    if (comrCodigo === null || comrCodigo === undefined || comrCodigo === '') {
      throw new Error('Parâmetro obrigatório: comrCodigo');
    }
    const suffix = '?comrCodigo=' + encodeURIComponent(comrCodigo);
    return this.rest.get(`${URL_API.PATH_SETOR_COMARCA_CARREGAR}` + suffix).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  getPerguntas(tema?: string) {
    const suffix = tema ? ('?tema=' + encodeURIComponent(tema)) : '';
    return this.rest.get(`${URL_API.PATH_PERGUNTA_GET_PERGUNTAS}` + suffix).pipe(
      retry(1),
      tap((ret: any) => {
        try {
          const lista = this.unwrap(ret) || [];
          (lista || []).forEach((p: any) => this.registrarPerguntaNoCache(p));
        } catch (e) { /* noop */ }
      }),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  private registrarPerguntaNoCache(pergunta: any): void {
    if (!pergunta) return;
    if (pergunta.id !== undefined && pergunta.id !== null) {
      this.perguntaById[String(pergunta.id)] = pergunta;
    }
    if (pergunta.opcoes && Array.isArray(pergunta.opcoes)) {
      pergunta.opcoes.forEach((opcao: any) => {
        const childPergunta = opcao ? opcao.childPergunta : null;
        const childs = Array.isArray(childPergunta) ? childPergunta : (childPergunta ? [childPergunta] : []);
        childs.forEach((child: any) => this.registrarPerguntaNoCache(child));
      });
    }
    const directChild = pergunta.childPergunta;
    const directChilds = Array.isArray(directChild) ? directChild : (directChild ? [directChild] : []);
    directChilds.forEach((child: any) => this.registrarPerguntaNoCache(child));
  }

  /**
   * Mapeia os dados do FormGroup `denuncia` para a entidade DenunciaAssedio
   * Retorna um objeto simples compatível com o JSON esperado pelo backend
   */
  mapearDenunciaAssedio(): any {

  const form = (this.denuncia && (this.denuncia as FormGroup).getRawValue) ? (this.denuncia as FormGroup).getRawValue() : (this.denuncia.value || {});
    // o formulário raiz contém 'denunciaAssedio' (conforme preencherVo())
    const assedioForm = form.denunciaAssedio || {};

    const resultado: any = {
      id: assedioForm.id || null,
      instancia: assedioForm.instancia || null,
      comarcaMunicipioCodigo: assedioForm.comarcaMunicipioCodigo || assedioForm.comarca || null,
      area: (assedioForm.area !== undefined && assedioForm.area !== null) ? assedioForm.area : null,
      setor: assedioForm.setorSigla || assedioForm.setor || null,
      setorOutro: assedioForm.setorOutro || null,
      aceiteTermo: assedioForm.aceiteTermo || 'N',
      condutas: [],
      participantes: [],
      respostas: []
    };

    // condutas: aceitar array de objetos ou array de ids
    const condutas = assedioForm.condutas || [];
    if (Array.isArray(condutas)) {
      condutas.forEach((c: any) => {
        if (typeof c === 'number') {
          resultado.condutas.push({ id: null, condutaId: c });
        } else if (c && (c.condutaId || c.id)) {
          resultado.condutas.push({ id: c.id || null, condutaId: c.condutaId || c.id });
        } else if (c && c.value) {
          resultado.condutas.push({ id: null, condutaId: c.value });
        }
      });
    }

    const participantes = assedioForm.participantes;
    if (Array.isArray(participantes) && participantes.length) {
      resultado.participantes = participantes.map((p: any) => {
        const funcaoIdToSend = this._resolveFuncaoId(p);
        const deficienciaIdToSend = this._resolveDeficienciaId(p);
        const hasFuncaoId = funcaoIdToSend !== undefined && funcaoIdToSend !== null && String(funcaoIdToSend).trim() !== '';
        const hasDeficienciaId = deficienciaIdToSend !== undefined && deficienciaIdToSend !== null && String(deficienciaIdToSend).trim() !== '';

        return {
          id: p.id || null,
          tipo: p.tipo,
          nome: p.nome,
          nomeSocial: p.nomeSocial || '',
          matricula: p.matricula || '',
          idade: p.idade || null,
          sexo: p.sexo || null,
          escolaridadeId: p.escolaridadeId || null,
          nacionalidade: p.nacionalidade || null,
          funcaoId: funcaoIdToSend,
          funcaoOutro: hasFuncaoId ? null : (p.funcaoOutro || null),
          possuiContato: p.possuiContato || null,
          deficienciaId: deficienciaIdToSend,
          deficienciaOutro: hasDeficienciaId ? null : (p.deficienciaOutro || null),
          corRacaId: p.corRacaId || null,
          orgaoVinculadoId: p.orgaoVinculadoId || null,
          orgaoVinculadoDescricao: p.orgaoVinculadoDescricao || null,
          telefone: p.telefone ? this._stripNonDigits(p.telefone) : null,
          celular: p.celular ? this._stripNonDigits(p.celular) : null,
          email: p.email || null,
          observacao: p.observacao || null
        };
      });
    }

    // respostas: normalizar respostas carregadas e depois sobrepor com os
    // controles dinâmicos atuais. Na edição, `respostas` vem do backend com
    // valores antigos, enquanto `pergunta_*` reflete o que foi alterado na tela.
    const respostas = assedioForm.respostas;
    if (Array.isArray(respostas) && respostas.length) {
      resultado.respostas = respostas.map((r: any, idx: number) => {
        const base: any = {
          participanteIndex: r.participanteIndex != null ? r.participanteIndex : r.participanteId != null ? 0 : null,
          participanteId: r.participanteId || null,
          perguntaId: r.perguntaId || null,
          perguntaCodigo: r.perguntaCodigo || null,
          perguntaText: r.perguntaText || null,
          respostaTipo: r.respostaTipo || null,
          respostaBoolean: r.respostaBoolean != null ? r.respostaBoolean : null,
          respostaTexto: r.respostaTexto || null,
          respostaChoice: r.respostaChoice || null,
          documentoProtocoloId: r.documentoProtocoloId || null,
          ordem: r.ordem || (idx + 1)
        };

        // se houver respostaChoice (ids) e faltar respostaTexto, tentar mapear labels usando perguntaById
        try {
          if ((!base.respostaTexto || base.respostaTexto === '') && base.respostaChoice && base.perguntaId != null) {
            const pid = String(base.perguntaId);
            const pergunta = this.perguntaById[pid];
            if (pergunta && pergunta.opcoes && pergunta.opcoes.length) {
              const parts = String(base.respostaChoice).split(',').map((s: string) => s.trim()).filter((s: string) => s !== '');
              const labels: string[] = [];
              const values: any[] = [];
              parts.forEach(pv => {
                const found = pergunta.opcoes.find((o: any) => String(o.val || o.value || o.id || o.valor) === pv);
                if (found) {
                  labels.push(found.label || found.nome || String(found));
                  values.push(found.val || found.value || found.id || found.valor || pv);
                } else {
                  labels.push(pv);
                  values.push(pv);
                }
              });
              base.respostaTexto = labels.join(',');
              base.respostaChoice = values.join(',');
              base.respostaTipo = parts.length > 1 ? 'CHOICE_MULTI' : 'CHOICE';
            }
          }
        } catch (e) { /* noop */ }

        return base;
      });
    }

    const dynamicRespostas: any[] = [];
    try {
      const grp = this.denuncia && (this.denuncia as FormGroup).get('denunciaAssedio') as FormGroup;
      if (grp && grp.controls) {
        Object.keys(grp.controls).forEach((subKey: string) => {
          if (subKey && subKey.startsWith('pergunta_')) {
            const perguntaId = subKey.replace('pergunta_', '');
            const ctrl: any = (grp as any).controls[subKey];
            const valor = ctrl ? ctrl.value : undefined;
            if (valor !== undefined) {
              dynamicRespostas.push(this._normalizeRespostaFromControl(perguntaId, valor));
            }
          }
        });
      }
    } catch (e) { /* noop */ }

    if (dynamicRespostas.length) {
      const respostasPorPergunta: { [perguntaId: string]: any } = {};
      (resultado.respostas || []).forEach((r: any) => {
        if (r && r.perguntaId != null) {
          respostasPorPergunta[String(r.perguntaId)] = r;
        }
      });
      dynamicRespostas.forEach((r: any) => {
        if (r && r.perguntaId != null) {
          respostasPorPergunta[String(r.perguntaId)] = r;
        }
      });
      resultado.respostas = Object.keys(respostasPorPergunta).map(k => respostasPorPergunta[k]);
    }

    // garantir que cada resposta tenha o campo `ordem` conforme a posição/ordem de exibição das perguntas
    try {
      // 1) Primeiro, se o formulário carregou um mapa explícito de ordens (componente produzindo perguntasOrdens), usar isso
      const ordemMap: { [id: string]: number } = {};
      try {
        const formOrdens = assedioForm.perguntasOrdens;
        if (formOrdens && typeof formOrdens === 'object' && Object.keys(formOrdens).length) {
          Object.keys(formOrdens).forEach(k => {
            try { ordemMap[String(k)] = Number(formOrdens[k]); } catch (e) { /* noop */ }
          });
        }
      } catch (e) { /* noop */ }

      // 2) Se mapa ainda estiver vazio, montar a partir do cache perguntaById ordenado por p.ordem
      if (!Object.keys(ordemMap).length) {
        const perguntasList = Object.values(this.perguntaById || {}).sort((a: any, b: any) => {
          const ao = a && a.ordem != null ? Number(a.ordem) : 0;
          const bo = b && b.ordem != null ? Number(b.ordem) : 0;
          return ao - bo;
        });

        perguntasList.forEach((p: any, idx: number) => {
          if (!p || p.id == null) return;
          const pid = String(p.id);
          ordemMap[pid] = p.ordem != null ? Number(p.ordem) : (idx + 1);
        });
      }

      resultado.respostas = resultado.respostas || [];

      // atribuir ordem às respostas existentes quando possível
      resultado.respostas.forEach((r: any) => {
        try {
          const pid = r && r.perguntaId != null ? String(r.perguntaId) : null;
          if (pid && ordemMap[pid] != null) {
            r.ordem = r.ordem != null && r.ordem !== '' ? r.ordem : ordemMap[pid];
          }
        } catch (e) { /* noop */ }
      });

      // Remover respostas vazias: manter apenas respostas com conteúdo (texto, choice ou boolean)
      resultado.respostas = (resultado.respostas || []).filter((r: any) => {
        try {
          const hasTexto = r.respostaTexto != null && String(r.respostaTexto).trim() !== '';
          const hasChoice = r.respostaChoice != null && String(r.respostaChoice).trim() !== '';
          const hasBoolean = r.respostaBoolean != null;
          return hasTexto || hasChoice || hasBoolean;
        } catch (e) { return false; }
      });
    } catch (e) { /* noop */ }

    return resultado;
  }

  /** Normaliza o valor de um controle de pergunta para o formato de resposta esperado */
  private _normalizeRespostaFromControl(perguntaId: any, valor: any): any {
    // valor pode ser boolean, string, array (checkbox) ou objeto
    const pergunta = perguntaId != null ? this.perguntaById[String(perguntaId)] : null;
    const resposta: any = {
      participanteIndex: null,
      participanteId: null,
      perguntaId: perguntaId ? Number(perguntaId) : null,
      perguntaCodigo: pergunta ? (pergunta.codigo || null) : null,
      perguntaText: pergunta ? (pergunta.perguntaText || pergunta.pergunta || null) : null,
      respostaTipo: pergunta ? (pergunta.tipo || null) : null,
      respostaBoolean: null,
      respostaTexto: null,
      respostaChoice: null,
      documentoProtocoloId: null,
      ordem: null
    };

    if (typeof valor === 'boolean') {
      resposta.respostaBoolean = valor;
      resposta.respostaTipo = 'BOOLEAN';
    } else if (typeof valor === 'string' || typeof valor === 'number') {
      // possível opção única (radio) enviada como primitivo — tentar mapear para CHOICE usando pergunta cache
      const pid = perguntaId != null ? String(perguntaId) : null;
      const pergunta = pid ? this.perguntaById[pid] : null;
      const primitive = String(valor);
      if (pergunta && pergunta.opcoes && pergunta.opcoes.length) {
        const found = pergunta.opcoes.find((o: any) => String(o.val || o.value || o.id || o.valor) === primitive);
        if (found) {
          resposta.respostaChoice = found.val || found.value || found.id || found.valor || primitive;
          resposta.respostaTexto = found.label || found.nome || String(found);
          resposta.respostaTipo = 'CHOICE';
          if (!resposta.perguntaText && pergunta.perguntaText) resposta.perguntaText = pergunta.perguntaText || pergunta.pergunta || null;
        } else {
          // não mapeou para opção conhecida -> tratar como texto livre
          resposta.respostaTexto = primitive;
          resposta.respostaTipo = 'TEXT';
        }
      } else {
        // sem definição da pergunta disponível -> considerar texto livre
        resposta.respostaTexto = primitive;
        resposta.respostaTipo = 'TEXT';
      }
    } else if (Array.isArray(valor)) {
        // checkbox: array de opções/enriched objects
        // extrair labels e values quando presentes; se receber primitivos (ids), tentar mapear labels
        const labels: string[] = [];
        const values: any[] = [];
        // tentar recuperar definição da pergunta para mapear ids -> labels
        const pid = perguntaId != null ? String(perguntaId) : null;
        const pergunta = pid ? this.perguntaById[pid] : null;
        if (Array.isArray(valor) && valor.length > 0) {
          valor.forEach((v: any) => {
            if (v == null) return;
            if (typeof v === 'object') {
              const lab = v.label || v.nome || v.texto || (v.perguntaText ? v.texto : null);
              if (lab) labels.push(String(lab));
              const val = v.value || v.val || v.id || v.valor || v;
              values.push(val);
              if (!resposta.perguntaText && v.perguntaText) resposta.perguntaText = v.perguntaText;
            } else {
              // primitivo: procurar opção correspondente na pergunta (se disponível)
              let mappedLabel: string | null = null;
              let mappedVal: any = v;
              if (pergunta && pergunta.opcoes && pergunta.opcoes.length) {
                const found = pergunta.opcoes.find((o: any) => String(o.val || o.value || o.id || o.valor) === String(v));
                if (found) {
                  mappedLabel = found.label || found.nome || String(found);
                  mappedVal = found.val || found.value || found.id || found.valor || v;
                }
              }
              labels.push(mappedLabel ? String(mappedLabel) : String(v));
              values.push(mappedVal);
            }
          });
        }
        resposta.respostaChoice = values.join(',');
        resposta.respostaTexto = labels.join(',');
        resposta.respostaTipo = 'CHOICE_MULTI';
    } else if (valor && typeof valor === 'object') {
      // objeto individual enriquecido (radio ou escolha única) ou tipo TEXT armazenado como objeto
      if (valor.tipo === 'TEXT' && (valor.texto !== undefined && valor.texto !== null)) {
        resposta.respostaTexto = String(valor.texto);
        resposta.respostaTipo = 'TEXT';
        if (valor.perguntaText) resposta.perguntaText = valor.perguntaText;
      } else {
        // objeto de opção escolhida
        resposta.respostaChoice = valor.value || valor.val || valor.id || valor.valor || null;
        resposta.respostaTexto = valor.label || valor.nome || null;
        resposta.respostaTipo = 'CHOICE';
        if (valor.perguntaText) resposta.perguntaText = valor.perguntaText;
      }
    }

    return resposta;
  }

  /**
   * Constrói o objeto `DenunciaAssedio` para envio a partir do formGroup atual
   */
  buildDenunciaAssedioPayload(): any {
    return this.mapearDenunciaAssedio();
  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      this.denuncia.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.denuncia.controls.listaUnidade.setValue(retorno.listaUnidade);
      this.denuncia.controls.assuntos.setValue(retorno.assuntos);
      // (OS 1202 - Colocar o carregamento das listas de municipios e serventias)
      this.denuncia.controls.listaMunicipio.setValue(retorno.listaMunicipio);
      this.denuncia.controls.listaComarcas.setValue(retorno.listaComarcas);
      this.denuncia.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      //this.denuncia.controls.listaOrigemNotificacaoCompleta.setValue(retorno.listaOrigemNotificacaoCompleta);
      this.denuncia.controls.listaOrigemNotificacaoPublicoExterno.setValue(retorno.listaOrigemNotificacaoPublicoExterno);
      this.denuncia.controls.listaOrigemNotificacaoPublicoInterno.setValue(retorno.listaOrigemNotificacaoPublicoInterno);
      this.denuncia.controls.listaOrgaoVinculadoAgressoresCompleta.setValue(retorno.listaOrgaoVinculadoAgressoresCompleta);

    });

  }

  carregarAreas() {
    return [
      { value: 0, nome: 'Área Administrativa' },
      { value: 1, nome: 'Área Judiciária' }
    ];
  }

  gravarManifestoOperador(manifestante: any, arquivos: any[] = [], isEnviar: boolean) {

    this.denuncia.controls.nome.setValue(manifestante.nome);
    this.denuncia.controls.email.setValue(manifestante.email);
    this.denuncia.controls.username.setValue(this.authService.usuarioLogado.username);

    this.denuncia.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.denuncia.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    return isEnviar ? this.enviar(this.denuncia.value) : this.salvar(this.denuncia.value);

  }

  salvar(obj: any) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  enviar(obj: any) {
    // garantir que o payload contenha a estrutura denunciaAssedio montada a partir do form
    try {
      obj.denunciaAssedio = this.buildDenunciaAssedioPayload();
    } catch (e) {
      // se algo falhar, não impedir o envio principal, mas logamos
      console.error('Erro ao montar denunciaAssedio payload', e);
    }
    return this.rest.post(`${URL_API.PATH_DENUNCIA}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  enviarDenunciaAnonima(obj: any) {
    return this.rest.post(`${URL_API.PATH_DENUNCIA_ANONIMA}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  gravar(obj: any) {
    try {
      obj.denunciaAssedio = this.buildDenunciaAssedioPayload();
    } catch (e) {
      console.error('Erro ao montar denunciaAssedio payload', e);
    }
    return this.rest.post(`${URL_API.PATH_DENUNCIA}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  atualizar(obj: DenunciaVO) {
    try {
      obj.denunciaAssedio = this.buildDenunciaAssedioPayload();
    } catch (e) {
      console.error('Erro ao montar denunciaAssedio payload', e);
    }
    return this.rest.put(`${URL_API.PATH_DENUNCIA}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  preencherVo() {
    return {
      id: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      files: null,
      assunto: new FormControl(null, [Validators.required]),
      descricaoDenuncia: new FormControl(null, [Validators.required]),
      anonimo: new FormControl(false, [Validators.required]),
      nome: new FormControl({ value: null }, [Validators.required]),
      email: new FormControl({ value: null }, [Validators.required]),
      listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      listaUnidade: [],
      unidadeAux1: new FormControl(null),
      unidadeAux2: new FormControl(null),
      assuntos: [],
      listaMunicipio: [],
      listaComarcas:[],
      listaServentia: [],
      codigoMunicipio: null,
      codigoCNS: null,
      nomeMunicipio: null,
      nomeServentia: null,
      localidade: null,
      codigoComarca: null,
      demandaRecebida: new FormControl(null),

      listaOrigemNotificacao: new FormControl([]),
      listaOrigemNotificacaoPublicoExterno: [],
      listaOrigemNotificacaoPublicoInterno: [],
      publicoOrigemNotificacao: new FormControl(null),
      tipoPessoaNotificante: new FormControl(null),
      nomeNotificante: new FormControl(null),
      nomeSocialNotificante: new FormControl(null),
      cpfCnpjNotificante: new FormControl(null),
      rgNotificante: new FormControl(null),
      orgaoExpedidorNotificante: new FormControl(null),
      ufOrgaoExpedidorNotificante: new FormControl(null),
      emailNotificante: new FormControl(null),
      vitimas: new FormControl(null),
      agressores: new FormControl(null),
      funcaoCargoAgressores: new FormControl(null),
      listaOrgaoVinculadoAgressores: new FormControl([]),
      listaOrgaoVinculadoAgressoresCompleta: [],
      outrosOrgaos: new FormControl(null),
      localFato: new FormControl(null),
      dataHoraFato: null,
      testemunhas: new FormControl(null),
      nomeUnidadePrisionalSocioeducativa: new FormControl(null),
      numeroDenunciaAnonima: null,
      infancia: this.builder.group({
        idComarca: new FormControl(null),
        indProcessoJudicial: new FormControl(null),
        numeroProcessoJudicial: new FormControl(null),
        demandas: new FormControl([]),
        nomeUnidadeAcolhimento: new FormControl(null)
      }),
      listaArea: [],
      listaConduta: [],
      listaFuncao: [],
      listaEscolaridade: [],
      listaTipoDeficiencia: [],
      listaCorRaca: [],
      listaSetor: [],
      denunciaAssedio: this.builder.group({
        id: new FormControl(null),
        instancia: new FormControl(null),
        comarcaMunicipioCodigo: new FormControl(null),
        area: new FormControl(null),
        setor: new FormControl(null),
        setorOutro: new FormControl(null),
        aceiteTermo: new FormControl(null),
        condutas: new FormControl([]),
        // Participantes iniciais: VÍTIMA e NOTICIADO — facilita bindings diretos no template
        participantes: this.builder.array([
          this.builder.group({
            id: new FormControl(null),
            tipo: new FormControl('VITIMA'),
            nome: new FormControl(null),
            nomeSocial: new FormControl(null),
            matricula: new FormControl(null),
            idade: new FormControl(null),
            sexo: new FormControl(null),
            escolaridadeId: new FormControl(null),
            nacionalidade: new FormControl(null),
            funcaoId: new FormControl(null),
            funcaoOutro: new FormControl(null),
            deficienciaId: new FormControl(null),
            deficienciaOutro: new FormControl(null),
            corRacaId: new FormControl(null),
            orgaoVinculadoId: new FormControl(null),
            orgaoVinculadoDescricao: new FormControl(null),
            telefone: new FormControl(null),
            celular: new FormControl(null),
            email: new FormControl(null)
          }),
          this.builder.group({
            id: new FormControl(null),
            tipo: new FormControl('NOTICIADO'),
            nome: new FormControl(null),
            nomeSocial: new FormControl(null),
            matricula: new FormControl(null),
            idade: new FormControl(null),
            sexo: new FormControl(null),
            escolaridadeId: new FormControl(null),
            funcaoId: new FormControl(null),
            funcaoOutro: new FormControl(null),
            deficienciaId: new FormControl(null),
            deficienciaOutro: new FormControl(null),
            corRacaId: new FormControl(null),
            orgaoVinculadoId: new FormControl(null),
            orgaoVinculadoDescricao: new FormControl(null),
            telefone: new FormControl(null),
            celular: new FormControl(null),
            email: new FormControl(null),
            possuiContato: new FormControl(null)
          })
        ]),
        respostas: new FormControl([])
      })
    } as DenunciaVO;
  }


  validaCamposDenunciaService(denuncia: FormGroup) {
    var mensagensErro = '';

    if (denuncia.value.assunto == null || denuncia.value.assunto === '') {
      mensagensErro = mensagensErro + MSG_OBG_ASSUNTO;
    }

    if (denuncia.value.listaClassificacao != null && denuncia.value.listaClassificacao.length === 0) {
      mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_CLASSIFICACAO;
    } else if (denuncia.value.listaClassificacao.length === 1) {

      var idClassificacao = denuncia.value.listaClassificacao[0].id;

      // Campos de Cartórios Extrajudiciais Capital
      if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL) {

        if (denuncia.value.codigoCNS == null || denuncia.value.codigoCNS == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_CARTORIO;
        }

        if (denuncia.value.localidade == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_LOCALIDADE;
        }

        // Campos de Cartórios Extrajudiciais Interior
      } else if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR) {

        if (denuncia.value.codigoMunicipio == null || denuncia.value.codigoMunicipio == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_MUNICIPIO;
        }

        if (denuncia.value.codigoCNS == null || denuncia.value.codigoCNS == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_CARTORIO;
        }

        if (denuncia.value.localidade == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_LOCALIDADE;
        }

        // Campos de Servidor Interior
      } else if (idClassificacao === this.CLASSIFICACAO_SERVIDOR_INTERIOR) {

        if (denuncia.value.codigoMunicipio == null || denuncia.value.codigoMunicipio == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_COMARCA;
        }
      }
      // Campos de Infância e Juventude
      else if (idClassificacao === 159) {
        const infancia = denuncia.get('infancia').value;
        console.log(infancia);
        if (infancia.idComarca == null || infancia.idComarca == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_COMARCA_OCORRENCIA;
        }

        if (infancia.indProcessoJudicial === 'true' && (infancia.numeroProcessoJudicial == null || infancia.numeroProcessoJudicial == '')) {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NUMERO_PROCESSO;
        }

        if (infancia.demandas == null || infancia.demandas.length === 0) {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_TIPOS_DEMANDA;
        } else if (infancia.demandas.includes(1) && (infancia.nomeUnidadeAcolhimento == null || infancia.nomeUnidadeAcolhimento == '')) {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_UNIDADE_ACOLHIMENTO;
        }
      }
      //Campos Tortura ou maus-tratos de pessoa sob custódia policial no Sistema Prisional ou Socioeducativo
      else if (idClassificacao === this.CLASSIFICACAO_TORTURA) {

        //Campo somente do Painel Operador
        if (!this.authService.isUsuarioExternoLogado() && !this.authService.isUsuarioGovBr()
            && (denuncia.value.publicoOrigemNotificacao == null || denuncia.value.publicoOrigemNotificacao == '')) {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_PUBLICO_ORIGEM_NOTIFICACAO;
        }
        //-------------------------------------------------------------//

        if (denuncia.value.listaOrigemNotificacao.length === 0) {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_ORIGEM_NOTIFICACAO;
        }

        if (denuncia.value.tipoPessoaNotificante == null || denuncia.value.tipoPessoaNotificante == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_TIPO_PESSOA_NOTIFICANTE;
        }

        if (denuncia.value.tipoPessoaNotificante == 'fisica') {

          if (denuncia.value.nomeNotificante == null || denuncia.value.nomeNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_NOTIFICANTE;
          }

          if (denuncia.value.nomeSocialNotificante == null || denuncia.value.nomeSocialNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_SOCIAL_NOTIFICANTE;
          }

          if (denuncia.value.cpfCnpjNotificante == null || denuncia.value.cpfCnpjNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_CPF_NOTIFICANTE;
          }

          if (denuncia.value.rgNotificante == null || denuncia.value.rgNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_RG_NOTIFICANTE;
          }

          if (denuncia.value.orgaoExpedidorNotificante == null || denuncia.value.orgaoExpedidorNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_ORGAO_EXPEDIDOR_NOTIFICANTE;
          }

          if (denuncia.value.ufOrgaoExpedidorNotificante == null || denuncia.value.ufOrgaoExpedidorNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_UF_ORGAO_EXPEDIDOR_NOTIFICANTE;
          }

          if (denuncia.value.emailNotificante == null || denuncia.value.emailNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_EMAIL_NOTIFICANTE;
          }

        }

        if (denuncia.value.tipoPessoaNotificante == 'juridica') {

          if (denuncia.value.nomeNotificante == null || denuncia.value.nomeNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_NOME_NOTIFICANTE;
          }

          if (denuncia.value.cpfCnpjNotificante == null || denuncia.value.cpfCnpjNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_CNPJ_NOTIFICANTE;
          }

          if (denuncia.value.emailNotificante == null || denuncia.value.emailNotificante == '') {
            mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_EMAIL_NOTIFICANTE;
          }

        }

        if (denuncia.value.vitimas == null || denuncia.value.vitimas == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_VITIMAS;
        }

        if (denuncia.value.listaOrgaoVinculadoAgressores.length === 0) {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_ORGAO_VINCULADO_AGRESSORES;
        }

  denuncia.value.listaOrgaoVinculadoAgressores.forEach((itemSelecionado: any) => {

          if (itemSelecionado.descricao === 'Outros') {

            if (denuncia.value.outrosOrgaos == null || denuncia.value.outrosOrgaos == '') {
              mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_OUTROS_ORGAOS;
            }

          }
        });

        if (denuncia.value.localFato == null || denuncia.value.localFato == '') {
          mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_LOCAL_FATO;
        }

      }

    }

    if (denuncia.value.descricaoDenuncia === '' || denuncia.value.descricaoDenuncia == null) {
      mensagensErro = mensagensErro + MSG_DENUNCIA_OBG_DESCRICAO_DENUNCIA;
    }

    return mensagensErro;
  }


  getProtocolo(): Observable<any> {
    return this.rest.post(`${URL_API.PATH_DENUNCIA_ANONIMA_SUCESSO}`).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  criarEstruturaTipoDetalhe(formulario: any) {
    const demandaTipos = [
      {val: 1, label: 'Unidade de Acolhimento', tooltip: null},
      {val: 2, label: 'Setor Técnico', tooltip: 'Setor técnico é referente a Assistente Social ou Psicólogo.'},
      {val: 3, label: 'Agente Voluntário de Proteção', tooltip: null},
      {val: 4, label: 'Comissariado', tooltip: null},
      {val: 5, label: 'Discriminação contra famílias homoafetivas e transafetivas', tooltip: null}
    ];

    const infancia = formulario.infancia;
    const demandas = infancia && infancia.demandas ? infancia.demandas : [];

    const demandasFormatadas = demandas.map(id => {
      const demanda = demandaTipos.find(d => d.val === id);

      if (!demanda) {
        return null;
      }

      return {
        tipoDetalhe: {
          id: demanda.val,
          nome: demanda.label,
          ...(demanda.tooltip
            ? { observacao: demanda.tooltip }
            : {})
        }
      };
    }).filter(item => item !== null);

    const payload = {
      ...formulario,
      infancia: {
        ...formulario.infancia,
        demandas: demandasFormatadas
      }
    };

    // Atualiza o formulário principal com as demandas formatadas
    this.infanciaGroup.get('demandas').setValue(demandasFormatadas, { emitEvent: false });
    return payload;
  }

  get infanciaGroup(): FormGroup {
    return this.denuncia.get('infancia') as FormGroup;
  }

}
